<script>
	// NPM Modules
	import dayjs from 'dayjs';
	// Components
	import LoadingButton from '@/Components/LoadingButton.svelte';
	// Stores
	import SportcastFixtureStore from '@/Stores/Sport/SportcastFixtureStore.js';
	// Services
	import { notify } from '@/Services/Notify.js';

	export let event;

	let remote_id = event.sportcast_fixture_id;
	let loading = false;

	$: sportcastEvents =
		$SportcastFixtureStore &&
		$SportcastFixtureStore
			.where('compId', event.competition.id)
			.where('start_time', '>', dayjs.utc(event.start_time).subtract(12, 'hour').format('YYYY-MM-DDTHH:mm:ssZ'))
			.where('start_time', '<', dayjs.utc(event.start_time).add(12, 'hour').format('YYYY-MM-DDTHH:mm:ssZ'));

	function updateEventMapping() {
		loading = true;
		SportcastFixtureStore.updateEventMapping(event.id, remote_id)
			.then(() => {
				notify({
					type: 'success',
					title: event.name,
					message: `Mapped to Sportcast Fixture ${
						$SportcastFixtureStore.where('id', remote_id).pluck('name').first() || 'N/A'
					}`,
					timeout: 3
				});
			})
			.catch((e) => {
				notify({
					type: 'danger',
					title: 'Error!',
					message: (e.error && e.error[0]) || 'Failed to Map event to Sportcast Fixture',
					timeout: 5
				});
			})
			.finally(() => (loading = false));
	}
</script>

<div class="inline-flex items-center gap-1.5">
	<select
		class="form-select text-xs py-1 px-2 h-7 w-48 focus:outline-none"
		style="line-height: 14px"
		name={event.id}
		bind:value={remote_id}
	>
		{#if event.sportcast_fixture_id && !sportcastEvents
				.all()
				.some((e) => parseInt(e.id) === parseInt(event.sportcast_fixture_id))}
			<option value={parseInt(event.sportcast_fixture_id)}>Already mapped</option>
		{/if}
		<option value={null}>Not mapped...</option>
		{#each sportcastEvents.all() as sportcastEvent (sportcastEvent.id)}
			<option value={parseInt(sportcastEvent.id)}>{sportcastEvent.name}</option>
		{:else}
			<option disabled>No fixtures found</option>
		{/each}
	</select>
	<LoadingButton
		{loading}
		className="btn btn-black text-xs py-1.5 px-3 h-6 whitespace-nowrap flex-shrink-0 leading-none"
		on:click={updateEventMapping}
	>
		Save
	</LoadingButton>
</div>
